import { Build } from "@stencil/core";

/* eslint-disable no-console */
const tag = "[zapier-elements]";

export const Logger = {
  info: console.info.bind(console, tag),
  error: console.error.bind(console, tag),
  log: console.log.bind(console, tag),
  warn: console.warn.bind(console, tag),
};

// Silence less important logs in tests
if (Build.isTesting) {
  Logger.info = () => {};
  Logger.log = () => {};
}
